<template lang="pug">
div
    BaseHeader(
        :titulo='$t("mensagens.gerenteTerritorial.labels.titulo")',
        :voltarPara='{ route: "ConfiguracaoGerentesTerritoriais" }'
    )
    .bloco-cadastro-gerenteTerritoriales
        h3 {{ $t('mensagens.gerenteTerritorial.labels.dadosCadastrais') }}
        .form-cadastro-gerenteTerritorial
            .form-cadastro-gerenteTerritorial__row
                label.form-cadastro-gerenteTerritorial__row-label {{ $t('mensagens.gerenteTerritorial.labels.gerenteComercial') }}
                el-select.w-50(
                    v-model='gerenteTerritorial.nomeGerenteComercial',
                    :placeholder='$t("mensagens.comuns.selecione")',
                    clearable,
                    :loading='loading.gerentesComerciais',
                    filterable
                )
                    el-option(
                        v-for='({ nome, id }, index) in gerentesComerciais',
                        :key='nome + id',
                        :id='index',
                        :label='nome',
                        :value='id'
                    )

            .form-cadastro-gerenteTerritorial__row
                label.form-cadastro-gerenteTerritorial__row-label.obrigatorio {{ $t('mensagens.gerenteTerritorial.labels.idBunge') }}
                input.form-cadastro-gerenteTerritorial__row-input(
                    :placeholder='$t("mensagens.gerenteTerritorial.labels.descricaoId")',
                    v-model='gerenteTerritorial.idBunge'
                )

            .form-cadastro-gerenteTerritorial__row
                label.form-cadastro-gerenteTerritorial__row-label.obrigatorio {{ $t('mensagens.gerenteTerritorial.labels.nome') }}
                input.form-cadastro-gerenteTerritorial__row-input(
                    :placeholder='$t("mensagens.gerenteTerritorial.labels.descricao")',
                    v-model='gerenteTerritorial.nome'
                )

        .footer
            .footer__btn.voltar(@click='goToListagemgerenteTerritoriales')
                i.mdi.mdi-arrow-left
                span {{ $t('mensagens.comuns.voltar') }}
            .footer__btn.salvar(@click='editargerenteTerritorial')
                span {{ $t('mensagens.comuns.salvar') }}
                i.mdi.mdi-arrow-right
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue';

import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';
import EventBus from '@/utils/eventBus';

export default {
    name: 'EditarGerenteTerritorial',
    props: ['row'],
    components: {
        BaseHeader
    },
    data() {
        return {
            gerenteTerritorial: {
                id: this.row.id,
                nome: this.row.nome,
                idBunge: this.row.idBunge,
                nomeGerenteComercial: this.row.nomeGerenteComercial
            },
            gerentesComerciais: [],
            loading: {
                gerentesComerciais: true
            }
        };
    },

    mounted() {
        this.buscarGerentesRegionais();
    },

    methods: {
        async buscarGerentesRegionais() {
            this.loadingScreen(true);
            this.loading.gerentesComerciais = true;

            const { data } =
                await ContratoOriginacaoService.buscarGerentesComerciais();

            if (data.length > 0) {
                this.gerenteTerritorial.nomeGerenteComercial =
                    this.loading.gerentesComerciais = false;

                let currentGerente = [];
                this.loading.gerentesComerciais = false;

                if (this.row.idGerenteComercial) {
                    currentGerente.push(
                        data?.find(
                            gerenteComercial =>
                                gerenteComercial.id ===
                                this.row.idGerenteComercial
                        )
                    );
                }

                if (currentGerente[0] === undefined) {
                    currentGerente = [];
                    this.gerentesComerciais = data;
                } else {
                    this.gerentesComerciais = [
                        ...currentGerente,
                        ...data.filter(
                            gerenteComercial =>
                                gerenteComercial.id !==
                                this.row.idGerenteComercial
                        )
                    ];
                }

                this.gerenteTerritorial.nomeGerenteComercial =
                    this.gerentesComerciais[0]?.id;

                if (!this.row.idGerenteComercial) {
                    this.gerenteTerritorial.nomeGerenteComercial = '';
                }
            }
            this.loadingScreen(false);
        },
        goToListagemgerenteTerritoriales() {
            this.$router.push({ name: 'ConfiguracaoGerentesTerritoriais' });
        },
        async editargerenteTerritorial() {
            const inputValido = this.validaInput();
            if (inputValido) {
                try {
                    const payload = this.montarPayload();

                    await ContratoOriginacaoService.editarGerenteTerritorial(
                        payload
                    );
                    this.$notify.success(
                        this.$t(
                            'mensagens.gerenteTerritorial.labels.registroEditado'
                        )
                    );
                    this.$router.push({
                        name: 'ConfiguracaoGerentesTerritoriais'
                    });
                } catch (error) {}
            }
        },
        validaInput() {
            if (
                !this.gerenteTerritorial.nome ||
                this.gerenteTerritorial.nome.trim() === ''
            ) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.gerenteTerritorial.labels.nomeVazio'
                    )
                });
                return false;
            }

            if (
                !this.gerenteTerritorial.idBunge ||
                this.gerenteTerritorial.idBunge.trim() === ''
            ) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.gerenteTerritorial.labels.idBungeVazio'
                    )
                });
                return false;
            }

            return true;
        },
        montarPayload() {
            return {
                id: this.gerenteTerritorial.id,
                nome: this.gerenteTerritorial.nome,
                idBunge: this.gerenteTerritorial.idBunge,
                idGerenteComercial: this.gerenteTerritorial.nomeGerenteComercial
            };
        },
        loadingScreen(isLoading) {
            const options = {
                mostrarLoading: isLoading,
                lockMessage: this.$t('mensagens.sistema.carregando')
            };
            EventBus.$emit('emit-componente-carregando', options);
        }
    }
};
</script>

<style lang="scss">
.bloco-cadastro-gerenteTerritoriales {
    margin: 20px;
}

.form-cadastro-gerenteTerritorial {
    margin-top: 10px;
    background-color: $white;
    padding: 15px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    border-radius: $default-border-radius;
    @include default-box-shadow();
}

.form-cadastro-gerenteTerritorial__row {
    display: flex;
    flex-direction: column;
    gap: 3px;
}

.form-cadastro-gerenteTerritorial__row-label {
    color: $primary;
    font-weight: bold;
}

.obrigatorio::after {
    content: '* ';
    color: red;
    margin-left: 3px;
}

.form-cadastro-gerenteTerritorial__row-input {
    width: 50%;
    height: 40px;
    border-radius: $default-border-radius;
    border: 1px solid $default-border-color;
    outline: 0;
    padding: 0 15px;
}

.form-cadastro-gerenteTerritorial__row-input-area {
    display: flex;
    gap: 10px;
    align-items: center;
}

.form-cadastro-gerenteTerritorial__btn-remover-cpf-cnpj {
    width: 48px;
    height: 32px;
    background-color: $background-danger;
    color: $font-danger;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: $default-border-radius;
}

.form-cadastro-gerenteTerritorial__btn-add-cpf-cnpj {
    width: 210px;
    height: 40px;
    margin-top: 5px;
    background-color: $white;
    color: $primary;
    font-weight: bold;
    border: 1px solid $primary;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 3px;
    border-radius: $default-border-radius;
    cursor: pointer;

    i.el-icon-plus {
        font-weight: bold;
    }
}

.form-cadastro-gerenteTerritorial__btn-add-cpf-cnpj:hover {
    background-color: var(--primary);
    color: $white;
}

.footer {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
}

.footer__btn {
    width: 100px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    border-radius: $default-border-radius;
    cursor: pointer;

    .mdi-arrow-left {
        color: var(--primary);
    }

    .mdi-arrow-right {
        color: $white;
    }
}

.salvar {
    background-color: var(--primary);
    color: $white;
}

.salvar:hover {
    background-color: var(--secondary);
}

.footer__btn.voltar {
    background-color: transparent;
    color: var(--primary);
    border: 1px solid var(--primary);
}

.footer__btn.voltar:hover {
    background-color: var(--primary);
    color: $white;

    .mdi-arrow-left {
        color: $white;
    }
}
</style>
